import { useState } from "react";

import { TabContext, TabPanel } from "@mui/lab";
import { Box, Button, Divider, Tab, Tabs, Tooltip, Typography } from "@mui/material";
import { FilterList } from "@mui/icons-material";
import { clientTheme } from "../../../theme/clientTheme";

const isModernTheme = clientTheme.layout?.portfolioCardVariant === "modern";

import { ContractorComparison } from "../components/ContractorComparison";
import { ContractorDetails } from "../components/ContractorDetails";
import { DrawerControl, FilterSideBar } from "../../../shared/components";
import { useCapabilities } from "../../../hooks/useCapabilities";
import { useFilterContext } from "../../../shared/context";
import { useActiveFilterLabels } from "../../../shared/hooks";

export const ContractorOversight = () => {

  const [currentTab, setCurrentTab] = useState("contractorComparison");
  const { isAllowedToViewContractorComparison, isAllowedToViewContractorDetails } = useCapabilities();
  const { hasActiveFilters, activeFilterLabels } = useActiveFilterLabels();

  const handleChangeTab = (_e: React.SyntheticEvent, tab: string) => {
    setCurrentTab(tab);
  };

  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);

  const handleOpenFilter = () => setIsOpenFilter(true);
  const handleCloseFilter = () => setIsOpenFilter(false);

  return (
    <Box height={"100%"} display={"flex"} flexDirection={"column"} overflow={"hidden"}>
      <TabContext value={currentTab}>
        <Box display="flex" alignItems="center" alignContent="center" pr={2}>
          <Tabs value={currentTab} onChange={handleChangeTab} aria-label="Tabs" variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile sx={{ minHeight: "auto" }}>
            {isAllowedToViewContractorComparison && (
              <Tab sx={{ height: "auto", minHeight: "auto" }} label={"Contractor Comparison"} value={"contractorComparison"} />
            )}
            {isAllowedToViewContractorDetails && (
              <Tab sx={{ height: "auto", minHeight: "auto" }} label={"Contractor Details"} value={"contractorDetails"} />
            )}
          </Tabs>
            <Tooltip
            title={
              hasActiveFilters ? (
                <Box sx={{ p: 0.5 }}>
                  {activeFilterLabels.map((label, i) => (
                    <Typography key={i} variant="caption" display="block">
                      {label}
                    </Typography>
                  ))}
                </Box>
              ) : ""
            }
            placement="bottom-start"
            disableHoverListener={!hasActiveFilters}
            arrow
          >
            <Button
              startIcon={<FilterList />}
              variant={isModernTheme ? "outlined" : (hasActiveFilters ? "contained" : "text")}
              color={isModernTheme ? "inherit" : "inherit"}
              onClick={handleOpenFilter}
              sx={
                isModernTheme
                  ? {
                    marginLeft: "auto",
                    borderRadius: 2,
                    textTransform: "none",
                    borderColor: "divider",
                    color: hasActiveFilters ? "primary.main" : "text.primary",
                    whiteSpace: "nowrap",
                  }
                  : hasActiveFilters
                  ? {
                    marginLeft: "auto",
                    backgroundColor: "action.selected",
                    color: "text.primary",
                    "&:hover": { backgroundColor: "action.hover" },
                  }
                  : { marginLeft: "auto" }
              }
            >
              {isModernTheme ? `Filters${hasActiveFilters ? ` (${activeFilterLabels.length})` : ""}` : `FILTERS${hasActiveFilters ? ` (${activeFilterLabels.length})` : ""}`}
            </Button>
          </Tooltip>
        </Box>
        <Divider />
        <TabPanel value="contractorComparison" sx={{ flexGrow: 1, p: 0, overflow: "auto" }}>
          <ContractorComparison />
        </TabPanel>
        <TabPanel value="contractorDetails" sx={{ flexGrow: 1, p: 0, overflow: "auto" }}>
          <ContractorDetails />
        </TabPanel>
      </TabContext>
      <DrawerControl
        title="Filter Records"
        subTitle="Please apply following filters to refine results"
        isOpen={isOpenFilter}
        handleClose={handleCloseFilter}
      >
        <FilterSideBar hiddenFilters={['stakeholder']} onClose={handleCloseFilter} />
      </DrawerControl>
    </Box>
  );

};